var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",attrs:{"width":"1920","height":"1080"}})
}
var staticRenderFns = []

export { render, staticRenderFns }